<template>
  <div class="page-wrap">
    <my-header
        :current-title="['发票业务', '发票额度调整申请', '新增申请']"
        main-title="新增申请"
        @back="emit('back')"
    />

    <div class="main-box">
      <el-form :model="formData" class="add-form"
               ref="formRef" :rules="rules" :inline="true" label-width="100px">
        <div class="info-block">
          <div class="title">基本信息</div>


          <div class="form-wrap">
            <el-row>
              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label="主管税务机关" prop="respTaxGovern">
                  <el-input
                      v-model="formData.respTaxGovern"
                      disabled
                      placeholder="请输入"/>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="60px"
                    label="申请人" prop="reqName">
                  <el-input
                      v-model="formData.reqName"
                      disabled
                      placeholder="请输入"/>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="100px"
                    label="发票赋额类别" prop="ticketTaxType">
                  <el-input
                      v-model="formData.ticketTaxType"
                      disabled
                      placeholder="请输入"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="70px"
                    label="申请日期" prop="reqDate">
                  <el-date-picker
                      type="date"
                      v-model="formData.reqDate"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      clearable
                      disabled
                      style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>

          </div>
        </div>

        <div class="info-block">
          <div class="title">申请额度调整信息</div>

          <div class="form-wrap">
            <el-row>
              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label="申请调整额度类型"
                    label-width="auto"
                    prop="adjustType">
                  <el-select
                      v-model="formData.adjustType"
                      placeholder="请选择"
                      @change="changeAdjustType"
                  >
                    <el-option label="短期" value="短期"/>
                    <el-option label="长期" value="长期"/>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label="发票额度短期调整类型"
                    label-width="auto"
                    prop="adjustShortType">
                  <el-select
                      :disabled="formData.adjustType == '长期'"
                      v-model="formData.adjustShortType"
                      placeholder="请选择"
                      @change="changeAdjustShortType"
                  >
                    <el-option label="当月" value="当月"/>
                    <el-option label="指定期间" value="指定期间"/>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="80px"
                    ref="validateStRef"
                    label="有效期起" prop="validateStart">
                  <el-date-picker
                      type="date"
                      v-model="formData.validateStart"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      :disabled-date="validateStartDisableDate"
                      clearable
                      placeholder="请选择"
                      :disabled="formData.adjustShortType == '当月'"
                      style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="80px"
                    ref="validateEnRef"
                    label="有效期止" prop="validateEnd">
                  <el-date-picker
                      type="date"
                      v-model="formData.validateEnd"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      clearable
                      :disabled-date="validateEndDisableDate"
                      placeholder="请选择"
                      :disabled="formData.adjustShortType == '当月' || formData.adjustType == '长期'"
                      style="width: 100%;"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="140px"
                    label="当月剩余额度（元）">
                  <el-input
                      v-model="formData.monthRemainAmount"
                      disabled
                      placeholder="请输入"/>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="150px"
                    prop="adjustBeforeAmount"
                    label="调整前当月发票总额度（元）">
                  <el-input
                      v-model="formData.adjustBeforeAmount"
                      disabled
                      placeholder="请输入"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="140px"
                    label="当月已使用额度（元）">
                  <el-input
                      v-model="formData.monthAlreadyAmount"
                      disabled
                      placeholder="请输入"/>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="140px"
                    prop="adjustAmount"
                    label="申请调整额度（元）">
                  <el-input
                      v-model="formData.adjustAmount"
                      placeholder="请输入"
                      @input="handleAdjustInput"
                      @blur="handleAdjustBlur"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                    class="my-form-item"
                    label-width="140px"
                    prop="adjustAfterAmount"
                    label="调整后发票总额度（元）">
                  <el-input
                      disabled
                      :model-value="`${formData.adjustAfterAmount}（${numberToChinese(convertToNumber(formData.adjustAfterAmount))}）`"
                      placeholder=""/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                    class="my-form-item"
                    label-width="80px"
                    prop="adjustReason"
                    label="申请理由">
                  <el-input
                      type="textarea"
                      :rows="2"
                      maxlength="1000"
                      show-word-limit
                      v-model="formData.adjustReason"
                      placeholder="请输入申请理由"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="info-block">
          <div class="title">附件资料</div>

          <el-collapse v-model="activeCollapse">
            <el-collapse-item icon="CaretRight" name="contractCol">

              <template #title>
                <div class="collapse-title">
                  <h3>购销合同</h3>

                  <span class="info">0个文件</span>
                </div>
              </template>

              <template #icon="{ isActive }">
              <span v-if="isActive" class="collapse-icon">
                <el-icon><ArrowUp/></el-icon>
                 收起
              </span>
                <span v-else class="collapse-icon">
                <el-icon><ArrowDown/></el-icon>
                  展开
              </span>
              </template>

              <div class="collapse-content">
                <el-row>
                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label="合同对象"
                        label-width="80px"
                        prop="purchaseContractObject">
                      <el-select
                          v-model="formData.purchaseContractObject"
                          placeholder="请选择"
                          :clearable="false"
                          @change="changePurchaseContractObject"
                      >
                        <el-option label="自然人" value="自然人"/>
                        <el-option label="单位（企业）" value="单位（企业）"/>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="formData.purchaseContractObject == '单位（企业）'">
                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="80px"
                        label="合同名称" prop="contractName">
                      <el-input
                          v-model="formData.contractName"
                          placeholder="请输入"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="125px"
                        label="合同商品或服务" prop="contractShopService">
                      <el-input
                          v-model="formData.contractShopService"
                          placeholder="请输入"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="80px"
                        prop="contractAmount"
                        label="合同金额">
                      <el-input
                          v-model="formData.contractAmount"
                          placeholder="请输入"/>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="formData.purchaseContractObject == '单位（企业）'">
                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="135px"
                        label="对方纳税人识别号" prop="otherSideCredit">
                      <el-input
                          v-model="formData.otherSideCredit"
                          placeholder="请输入"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="80px"
                        label="对方名称" prop="otherSideName">
                      <el-input
                          v-model="formData.otherSideName"
                          placeholder="请输入"/>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="80px"
                        ref="validateConStRef"
                        label="有效期起" prop="contractValidateStart">
                      <el-date-picker
                          type="date"
                          v-model="formData.contractValidateStart"
                          :disabled-date="contractStartDisableDate"
                          format="YYYY-MM-DD"
                          value-format="YYYY-MM-DD"
                          clearable
                          style="width: 100%;"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="formData.purchaseContractObject == '单位（企业）'">
                  <el-col :span="6">
                    <el-form-item
                        class="my-form-item"
                        label-width="80px"
                        ref="validateConStRef"
                        label="有效期止" prop="contractValidateEnd">
                      <el-date-picker
                          type="date"
                          v-model="formData.contractValidateEnd"
                          :disabled-date="contractEndDisableDate"
                          format="YYYY-MM-DD"
                          value-format="YYYY-MM-DD"
                          clearable
                          :disabled="formData.contractLong"
                          style="width: 100%;"
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <div style="padding-top: 30px;">
                      <el-checkbox
                          @change="changeContractLong"
                          v-model="formData.contractLong">长期合同
                      </el-checkbox>
                    </div>
                  </el-col>
                </el-row>

                <el-upload
                    :limit="999"
                    accept=".xlsx, .xls"
                    name="file"
                    :auto-upload="false"
                >
                  <el-button icon="Upload">上传文件</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="color: #999999;">
                      仅支持pdf、ofd、jpg、png、bmp格式文件上传，大小在10M以内！
                    </div>
                  </template>
                </el-upload>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse>
            <el-collapse-item icon="CaretRight">

              <template #title>
                <div class="collapse-title">
                  <h3>固定资产情况表</h3>

                  <span class="info">0个文件</span>
                </div>
              </template>

              <template #icon="{ isActive }">
              <span v-if="isActive" class="collapse-icon">
                <el-icon><ArrowUp/></el-icon>
                 收起
              </span>
                <span v-else class="collapse-icon">
                <el-icon><ArrowDown/></el-icon>
                  展开
              </span>
              </template>

              <div class="collapse-content">

                <el-upload
                    :limit="999"
                    accept=".xlsx, .xls"
                    name="file"
                    :auto-upload="false"
                >
                  <el-button icon="Upload">上传文件</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="color: #999999;">
                      仅支持pdf、ofd、jpg、png、bmp格式文件上传，大小在10M以内！
                    </div>
                  </template>
                </el-upload>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse>
            <el-collapse-item icon="CaretRight">

              <template #title>
                <div class="collapse-title">
                  <h3>其他材料</h3>

                  <span class="info">0个文件</span>
                </div>
              </template>

              <template #icon="{ isActive }">
              <span v-if="isActive" class="collapse-icon">
                <el-icon><ArrowUp/></el-icon>
                 收起
              </span>
                <span v-else class="collapse-icon">
                <el-icon><ArrowDown/></el-icon>
                  展开
              </span>
              </template>

              <div class="collapse-content">

                <el-upload
                    :limit="999"
                    accept=".xlsx, .xls"
                    name="file"
                    :auto-upload="false"
                >
                  <el-button icon="Upload">上传文件</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="color: #999999;">
                      仅支持pdf、ofd、jpg、png、bmp格式文件上传，大小在10M以内！
                    </div>
                  </template>
                </el-upload>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="info-block">
          <div style="display: flex;justify-content: center;">
            <el-button @click="emit('back')">返回</el-button>
            <el-button type="primary" @click="submit">申请</el-button>
          </div>

        </div>

      </el-form>


      <footer style="display: flex;justify-content: center;padding: 30px 0 0px 0;opacity: 0.9;">
        <img src="https://static.rhkj.com/renhe_fe/other/333.png">
      </footer>
    </div>


  </div>
</template>

<script setup lang="jsx">
import myHeader from "../cmp/myHeader.vue";
import dayjs from "dayjs";
import {ElMessage, ElMessageBox} from "element-plus";
import Big from "big.js";
import {numberToChinese, convertToNumber} from "@/utils/ruoyi.js";

const validateStRef = ref()
const validateEnRef = ref()
const formRef = ref()
const activeCollapse = ref([''])

const formData = ref({
  respTaxGovern: '国家税务总局武汉东湖新技术开发区税务局',
  reqName: '戢利霞',
  ticketTaxType: 'III类纳税人',
  reqDate: dayjs().format('YYYY-MM-DD'),
  monthRemainAmount: '400,000',
  adjustBeforeAmount: '400,000',
  monthAlreadyAmount: '0.00',
  adjustAmount: '0',
  purchaseContractObject: '自然人',
  adjustAfterAmount: '400,000',

})

const rules = reactive({
  adjustType: {required: true, message: '必选', trigger: ['blur', 'change']},
  adjustShortType: {required: false, message: '必选', trigger: ['blur', 'change']},
  validateStart: {required: true, message: '必选', trigger: ['blur', 'change']},
  validateEnd: {required: true, message: '必选', trigger: ['blur', 'change']},
  adjustBeforeAmount: {required: true, message: '必填', trigger: ['blur', 'change']},
  adjustAmount: {required: true, message: '必填', trigger: ['blur', 'change']},
  adjustAfterAmount: {required: true, message: '必填', trigger: ['blur', 'change']},
  adjustReason: {required: true, message: '必填', trigger: ['blur', 'change']},
  purchaseContractObject: {required: true, message: '必填', trigger: ['blur', 'change']},
  contractName: {required: true, message: '必填', trigger: ['blur', 'change']},
  contractShopService: {required: true, message: '必填', trigger: ['blur', 'change']},
  contractAmount: {required: true, message: '必填', trigger: ['blur', 'change']},
  otherSideCredit: {required: true, message: '必填', trigger: ['blur', 'change']},
  otherSideName: {required: true, message: '必填', trigger: ['blur', 'change']},
  contractValidateStart: {required: true, message: '必填', trigger: ['blur', 'change']},
  contractValidateEnd: {required: true, message: '必填', trigger: ['blur', 'change']},
})

// 申请调整额度类型change
function changeAdjustType() {
  rules.adjustShortType.required = formData.value.adjustType == '短期'
  formData.value.adjustShortType = undefined
  if (formData.value.adjustType == '长期') {
    formData.value.validateStart = dayjs().format('YYYY-MM-DD')
    formData.value.validateEnd = '2099-12-31'
  } else if (formData.value.adjustType == '短期') {
    formData.value.validateStart = dayjs().format('YYYY-MM-DD')
    formData.value.validateEnd = dayjs().endOf('month').format('YYYY-MM-DD')
  }
}

// 发票额度短期调整类型change
function changeAdjustShortType() {
  if (formData.value.adjustShortType == '当月') {
    formData.value.validateStart = dayjs().format('YYYY-MM-DD')
    formData.value.validateEnd = dayjs().endOf('month').format('YYYY-MM-DD')
    validateStRef.value.clearValidate()
    validateEnRef.value.clearValidate()
  }
}

//长期合同change
function changeContractLong() {
  if (formData.value.contractLong) {
    formData.value.contractValidateEnd = '2099-12-31'
  }
}

// 更换合同对象：自然人、企业
function changePurchaseContractObject() {
  formData.value.contractName = undefined
  formData.value.contractShopService = undefined
  formData.value.contractAmount = undefined
  formData.value.otherSideCredit = undefined
  formData.value.otherSideName = undefined
  formData.value.contractValidateStart = undefined
  formData.value.contractValidateEnd = undefined
  formData.value.contractLong = undefined
}

async function submit() {
  await formRef.value.validate(valid => {
    if (valid) {
      const vnode = <div style="line-height: 22px;">
        <div style="display:flex;justify-content: center;padding: 30px 0 10px 0;">
          <svg viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg" width="55" height="55">
            <path
                d="M874.119618 149.859922A510.816461 510.816461 0 0 0 511.997 0.00208a509.910462 509.910462 0 0 0-362.119618 149.857842c-199.817789 199.679789-199.817789 524.581447 0 724.260236a509.969462 509.969462 0 0 0 362.119618 149.857842A508.872463 508.872463 0 0 0 874.119618 874.120158c199.836789-199.679789 199.836789-524.581447 0-724.260236zM814.94268 378.210681L470.999043 744.132295a15.359984 15.359984 0 0 1-5.887994 4.095996c-1.751998 1.180999-2.913997 2.362998-5.276994 2.913997a34.499964 34.499964 0 0 1-13.469986 2.914997 45.547952 45.547952 0 0 1-12.897986-2.303998l-4.095996-2.363997a45.291952 45.291952 0 0 1-7.009992-4.095996l-196.902793-193.789796a34.126964 34.126964 0 0 1-10.555989-25.186973c0-9.37399 3.583996-18.74698 9.98399-25.186974a36.429962 36.429962 0 0 1 50.372947 0l169.98382 167.423824L763.389735 330.220732a37.059961 37.059961 0 0 1 50.371947-1.732998 33.647965 33.647965 0 0 1 11.165988 25.186973 35.544963 35.544963 0 0 1-9.98399 24.575974v-0.04z m0 0"
                fill="#52C41A" p-id="2618"></path>
          </svg>
        </div>
        <div
            style="text-align: center;padding-bottom:10px;">您的申请已提交成功，本次申请需税务人员“人工审核”。审核完成后系统将实时返回审批结果。请耐心等待。
        </div>
      </div>
      ElMessageBox.confirm(vnode, '', {
        confirmButtonText: '确定',
        type: '',
      })
          .finally(() => {
            emit('afterAdd', formData.value)
          })
    } else {
      ElMessage({
        message: '检查必填项',
        type: 'warning',
        duration: 3000
      })
      activeCollapse.value = ['contractCol']
    }
  })
}

// 有效期起--限制
function validateStartDisableDate(date) {
  if (dayjs(date).isBefore(dayjs().startOf('day'))) {
    return true
  } // 之前的时间也不让选择

  // 开始时间不能大于结束时间
  if (formData.value.validateEnd && dayjs(date).isAfter(dayjs(formData.value.validateEnd, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }

  const cur = dayjs(date).format('YYYY-MM-DD')
  // 只能选今天和每个月的1号
  return cur != dayjs().format('YYYY-MM-DD') && !cur.endsWith('-01')
}

// 有效期止--限制
function validateEndDisableDate(date) {
  if (dayjs(date).isBefore(dayjs().startOf('day'))) {
    return true
  } // 之前的时间也不让选择

  // 开始时间不能大于结束时间
  if (formData.value.validateStart && dayjs(date).isBefore(dayjs(formData.value.validateStart, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }

  const cur = dayjs(date).format('YYYY-MM-DD')
  const last = dayjs(date).endOf('month').format('YYYY-MM-DD')
  // 只能选每个月的最后一天
  return cur != last
}

// 合同有效期起
function contractStartDisableDate(date) {
  // 开始时间不能大于结束时间
  if (formData.value.contractValidateEnd && dayjs(date).isAfter(dayjs(formData.value.contractValidateEnd, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  if (dayjs(date).isBefore(dayjs().startOf('day'))) {
    return true
  }
  return false
}

// 合同有效期止
function contractEndDisableDate(date) {
  // 开始时间不能大于结束时间
  if (formData.value.contractValidateStart && dayjs(date).isBefore(dayjs(formData.value.contractValidateStart, 'YYYY-MM-DD').startOf('day'))) {
    return true
  }
  return false
}

const emit = defineEmits(['back', 'afterAdd']);

function handleAdjustInput(e) {
  let value = e.replace(/[^\d.]/g, '');
  const dotCount = (value.match(/[.]/g) || []).length;
  if (dotCount > 1) {
    value = value.replace(/[.](?=.*[.])/g, '');
  }
  if (value.startsWith('.')) {
    value = '0' + value;
  }
  const [integer, decimal] = value.split('.');
  if (decimal?.length > 2) {
    value = `${integer}.${decimal.slice(0, 2)}`;
  }
  formData.value.adjustAmount = value
}

function handleAdjustBlur() {
  if (formData.value.adjustAmount) {
    const num = parseFloat(formData.value.adjustAmount);
    formData.value.adjustAmount = num.toLocaleString('en-US', {
      //minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    // 调整后金额计算
    let res = parseFloat(new Big(convertToNumber(formData.value.adjustBeforeAmount)).plus(new Big(num)).valueOf())
    res = res.toLocaleString('en-US', {
      //minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    formData.value.adjustAfterAmount = res
  }
}
</script>

<style scoped lang="scss">
.page-wrap {
  .main-box {
    height: calc(100vh - 116px);
    background-color: #f2f2f2;
    box-sizing: border-box;
    padding: 24px;
    overflow-y: auto;

    .info-block {
      background-color: #FFFFFF;
      padding: 24px;

      .title {
        height: 28px;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        padding-bottom: 24px;
        border-bottom: 1px solid #DDDDDD;
        margin-bottom: 24px;
      }

      :deep(.my-form-item) {
        display: block;
      }

      :deep(.el-collapse) {
        border: none;

        .el-collapse-item {
          border: 1px solid rgb(234, 234, 234);
          padding-right: 24px;

          .el-collapse-item__wrap, .el-collapse-item__header {
            border-bottom: none;
          }

          .collapse-title {
            display: flex;
            align-items: center;
            flex-grow: 1;
            color: rgba(0, 0, 0, 0.9) !important;

            > h3 {
              font-size: 20px;
              font-weight: 400;
              line-height: 24px;
              margin-left: 24px;
              width: 50%;
              text-align: left;
            }
          }

          .collapse-icon {
            color: var(--el-color-primary);
          }

          .collapse-content {
            padding-left: 24px;
          }
        }

        & + .el-collapse {
          margin-top: 20px;
        }
      }

      & + .info-block {
        margin-top: 24px;
      }
    }
  }
}
</style>
